import * as ResourceApi from 'api/resources';

// Object detailing which fields to set after a resource is saved
// The resource type as the key
// Value is a set of fields, who's value is an array of fields that should be updated when the set field is saved
export default {
    [ResourceApi.Types.Break]: {
        breakTagLabels: ['breakTags'],
        prizingTiedStep: ['setSweepsDate', 'setSweepsStartDate', 'setSweepsEndDate']
    },
    [ResourceApi.Types.MemoryMatchGame]: {
        numCards: ['cards']
    },
    [ResourceApi.Types.ReceiptVerificationCampaign]: {
        rewardType: ['requireAddress', 'approvedEmailData']
    },
    [ResourceApi.Types.DragAndDropCardStack]: {
        dragDropType: ['cards', 'gridSize'],
        gridSize: ['cards']
    },
    [ResourceApi.Types.TextTriviaQuestion]: {
      defaultImageId: ['defaultImage']
    },
    [ResourceApi.Types.PrizeEntry]: {
        dateOrdered: ['status']
    },
    [ResourceApi.Types.ReferralLink]: {
        buttonType: ['menu']
    }
}



// WEBPACK FOOTER //
// ./public/resources/setAfterSaveConfig.js